import { useEffect } from 'react';

const Hero = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const parallaxElements = document.querySelectorAll('.hero-parallax');
      
      parallaxElements.forEach(element => {
        const speed = element.getAttribute('data-speed');
        if (speed) {
          const yPos = scrollPosition * parseFloat(speed);
          element.setAttribute('style', `transform: translateY(${yPos}px)`);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section id="home" className="relative h-screen overflow-hidden">
      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-center items-center p-4 md:p-8 lg:p-12">
        <div className="hero-parallax" data-speed="-0.1">
          <div className="bg-white/5 backdrop-blur-md p-8 md:p-12 max-w-3xl text-center pixel-border animate-pixel-fade-in">
            <h1 className="pixel-heading text-white drop-shadow-[2px_2px_0px_rgba(0,0,0,0.8)]">
              Hello, I'm <span className="text-grass-light">Alex Pixel</span>
            </h1>
            <h2 className="pixel-subheading text-white/90 drop-shadow-[1px_1px_0px_rgba(0,0,0,0.8)]">
              Software Engineer & Pixel Art Enthusiast
            </h2>
            <p className="text-white/80 font-degular mt-6 max-w-xl mx-auto animate-pixel-fade-in opacity-0 delay-6">
              Building elegant code solutions during the day,<br />crafting pixel worlds by night.
            </p>
            
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center animate-pixel-fade-in opacity-0 delay-8">
              <a href="#projects" className="pixel-btn bg-forest text-white hover:bg-forest-light w-full sm:w-auto">
                View Projects
              </a>
              <a href="#contact" className="pixel-btn w-full sm:w-auto">
                Contact Me
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Removing the Pixel Transition element from the bottom */}
    </section>
  );
};

export default Hero;